import {
  ProcessFlowchartNodeAdapter,
  ProcessFlowchartTaskSchemaNodeAdapter,
} from 'processes/graph-builder-processes/flowchart-viz/horizontal-flowchart/nodes/ProcessFlowchartNodeAdapter';
import {PLUGIN_REGISTRY_INSTANCE} from 'processes/graph-builder-processes/platform/PluginRegistry';

import {
  FlowchartNode,
  isInteractiveTaskNode,
  isStaticPlaceholderNodeData,
  isStaticTaskSchemaNodeData,
  StaticFlowchartNodeData,
} from './processFlowchartConfigEditorNodeTypes';

export function getAdapterForNode(
  node: FlowchartNode | null
): ProcessFlowchartTaskSchemaNodeAdapter<unknown, unknown> | ProcessFlowchartNodeAdapter | null {
  return getAdapterForNodeData(node?.data ?? null);
}

export function getAdapterForNodeData(
  nodeData: StaticFlowchartNodeData | null
): ProcessFlowchartTaskSchemaNodeAdapter<unknown, unknown> | ProcessFlowchartNodeAdapter | null {
  if (nodeData == null) {
    return null;
  }
  if (isStaticTaskSchemaNodeData(nodeData)) {
    return PLUGIN_REGISTRY_INSTANCE.getTaskSchemaNodeAdapter(
      nodeData.taskDefinitionVersionSpec.newProcessTaskDefinitionVersion.taskSchema.executionType
    );
  }
  if (isStaticPlaceholderNodeData(nodeData)) {
    return null;
  }
  return PLUGIN_REGISTRY_INSTANCE.getNodeAdapter(nodeData.nodeType);
}

export function getAdapterForTaskSchemaNode(
  node: FlowchartNode | null
): ProcessFlowchartTaskSchemaNodeAdapter<unknown, unknown> | null {
  if (node && isInteractiveTaskNode(node)) {
    return PLUGIN_REGISTRY_INSTANCE.getTaskSchemaNodeAdapter(
      node.data.taskDefinitionVersionSpec.newProcessTaskDefinitionVersion.taskSchema.executionType
    );
  }
  return null;
}

/**
 * Returns whether a node is deletable based on its adapter.
 */
export function isNodeDeletable(node: FlowchartNode): boolean {
  const adapter = getAdapterForNode(node);
  if (adapter == null) {
    return true;
  }
  return adapter.isDeletable();
}
